export const EXCMAGREEMENTTYPE_SHOW_RESET = 'EXCMAGREEMENTTYPE_SHOW_RESET'
export const EXCMAGREEMENTTYPE_SHOW_SET_ERROR = 'EXCMAGREEMENTTYPE_SHOW_SET_ERROR'
export const EXCMAGREEMENTTYPE_SHOW_SET_RETRIEVED = 'EXCMAGREEMENTTYPE_SHOW_SET_RETRIEVED'
export const EXCMAGREEMENTTYPE_SHOW_TOGGLE_LOADING = 'EXCMAGREEMENTTYPE_SHOW_TOGGLE_LOADING'
